import React from 'react'
import { alpha, styled } from '@mui/system'
import MuiButton, { ButtonProps as ButtonPropsMui } from '@mui/material/Button'
import { Loader } from '../Loader'

export const buttonDefaultProps: Partial<ButtonProps> = {
  variant: 'contained',
  disableElevation: true,
  disableRipple: true,
}

const StyledButton = styled(MuiButton)<ButtonProps>(({ theme }) => {
  return {
    height: '48px',
    textTransform: 'none',
    fontSize: '1rem',
    fontWeight: 400,
    borderRadius: '8px',

    '&.MuiButton-contained': {
      '&Primary': {
        '&.Mui-disabled': {
          backgroundColor: alpha(theme.palette.primary.light, 0.16),
          color: theme.palette.primary.light,
        },
        '&:hover': {
          backgroundColor: alpha(theme.palette.primary.main, 0.76),
        },
      },

      '&Secondary': {
        backgroundColor: alpha(theme.palette.primary.light, 0.48),
        color: theme.palette.primary.main,
        '&.Mui-disabled': {
          backgroundColor: alpha(theme.palette.primary.light, 0.16),
          color: theme.palette.primary.light,
        },
        '&:hover': {
          backgroundColor: theme.palette.primary.light,
        },
      },

      '&White': {
        '&.Mui-disabled': {
          backgroundColor: theme.palette.white.light,
          color: theme.palette.white.semiDark,
        },
        '&:hover > svg': {
          color: theme.palette.primary.main,
        },
      },
    },
  }
})

export interface ButtonProps extends ButtonPropsMui {
  loading?: boolean
}

export const Button: React.FC<ButtonProps> = ({ loading, disabled, children, ...props }) => (
  // @ts-ignore
  <StyledButton {...props} disabled={disabled || loading}>
    {loading && <Loader size="small" style={{ marginRight: 10 }} />}
    {children}
  </StyledButton>
)
